import React from 'react';
import { Button, ButtonTemplateProps, ButtonVariant } from '..';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';

interface SaveChangesButtonProps extends ButtonTemplateProps {}

export default function SaveChangesButton(props: SaveChangesButtonProps) {
  return <Button variant={ButtonVariant.primary} text={t(TranslationKey.saveChanges).singular.upper} {...props} />;
}
